module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/ticket-alt.svg?199705004da5eb30007d445c14cb1169";